import { createRoutine } from 'redux-saga-routines';
import { ACTION_SNOWFLAKE_INTRODUCTION_SEEN } from '@/constants';

export default createRoutine(ACTION_SNOWFLAKE_INTRODUCTION_SEEN);
